module.exports = __webpack_public_path__ + "static/media/testi_1.4e840540.jpg";